import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../../shared/api/client'
import type {
  ProcurementPartHistoryDto,
  ProcurementStaleItemDetailDto,
  ProcurementSupplierDetailDto,
} from './types'

export function useSupplierDetail(name: string | null) {
  return useQuery({
    enabled: name !== null,
    queryKey: ['dashboard', 'procurement', 'supplier', name],
    queryFn: async () => {
      const res = await apiClient.get<{ success: true; data: ProcurementSupplierDetailDto }>(
        '/dashboard/procurement/supplier',
        { params: { name } },
      )
      return res.data.data
    },
  })
}

export function useProcurementPartHistory(
  target: { partNumber: string; brand: string | null } | null,
) {
  return useQuery({
    enabled: target !== null,
    queryKey: ['dashboard', 'procurement', 'part-history', target?.partNumber, target?.brand],
    queryFn: async () => {
      const res = await apiClient.get<{ success: true; data: ProcurementPartHistoryDto }>(
        '/dashboard/procurement/part-history',
        { params: { partNumber: target!.partNumber, brand: target!.brand ?? undefined } },
      )
      return res.data.data
    },
  })
}

export function useStaleItemDetail(itemId: string | null) {
  return useQuery({
    enabled: itemId !== null,
    queryKey: ['dashboard', 'procurement', 'stale-item', itemId],
    queryFn: async () => {
      const res = await apiClient.get<{ success: true; data: ProcurementStaleItemDetailDto }>(
        `/dashboard/procurement/stale-item/${itemId}`,
      )
      return res.data.data
    },
  })
}
